"use client";
import ToolsStack from "@/components/section-infographic/DesignAndDevelopmentAsAService/ToolsStack";
import CaseStudiesMutiPurposeZigZagSection from "@/components/ui/CaseStudiesMutiPurposeZigZagSection";
import CaseStudyEngageMentModel from "@/components/ui/CaseStudyEngageMentModel";
import CommentSection from "@/components/ui/CommentSection";
import CTABanner from "@/components/organisms/CTABanner";
import VideoSection from "@/components/ui/VideoSection";

import CaseStudiesIntroBanner from "@/components/ui/CaseStudiesIntroBanner";
import CaseStudiesNewMegaCardSection from "@/components/ui/CaseStudiesNewMegaCarSection";
import CaseStudiesSkewSatusCardsSection from "@/components/ui/CaseStudiesSkewSatusCardsSection";
import ImageMarquee from "@/components/ui/ImageMarquee";
import SectionTitle from "@/components/ui/SectionTitle";
import IndustryHero from "@/components/SectionHero/IndustryHero";

import RelatedCaseStudies from "@/components/ui/RelatedCaseStudies";
import UniversalTable from "@/components/UniversalTable";
import TheChallengeScrollSection from "@/components/ui/TheChallengeScrollSection";
import RedRibbonBanner from "@/components/ui/RedRibbonBanner";



export default function BoardGamesCasestudyPage() {



    const clients = [

        {
            label: "CLIENT",
            name: "Oh My Print Solutions",

        },
        {
            label: "INDUSTRY",
            name: "Printing / Digital Printing / Large-Format Print Solutions",

        },
        {
            label: "Engagement Type",
            description: "Performance Marketing: Google Ads Campaign Management",
        },


    ];

    const skewCards = [
        {
            title: "20%",
            description: "Reduction in cost per conversion",
        },
        {
            title: "2x",
            description: "Improvement in conversion rate and CTR within 3 months",
        },
        {
            title: "70%",
            description: "Increase in number of orders",
        },
        {
            title: "50%",
            description: "Increase in phone calls",
        },
    ];


    return (
        <main className="overflow-hidden">

            <IndustryHero svgPath="/HeroSectionImg/OhMyPrintSolutions-HeroImage.svg" />
            <CaseStudiesIntroBanner
                title="How Oh My Print Solutions Reduced Cost Per Conversion by 20% with Performance-Led Google Ads"
                subtitle=""
                imageSrc="/logo/OhMyPrintSolutions.svg"
                imageAlt="Board Games"
            />

            <CaseStudiesSkewSatusCardsSection clients={clients} skewCards={skewCards} clientIntroPara="Oh My Print Solutions, a Vancouver-based large-format and digital print supplier brokerage, needed a stronger paid search engine to generate qualified leads, improve campaign efficiency and reduce high conversion costs in a competitive printing market." />

            <section className=" relative overflow-hidden border-y border-[#EDEDED] ">
                < VideoSection src="/video/" poster="/Thumbnails/OhMyPrintSolutions.png" />
            </section>



            <TheChallengeScrollSection
                sectionTitle={{
                    title: "The Challenge",
                    description: [
                        "Oh My Print Solutions was operating in a highly competitive print services market where established brands were already bidding for high-intent search traffic. The client needed to reach the right audience cost-effectively, generate qualified leads, improve the value of search campaigns and reduce the cost per conversion.",

                        "The existing challenge was not just about getting more clicks. The business needed better-quality traffic, stronger campaign segmentation, sharper ad messaging, and conversion-focused optimization so paid search could contribute directly to customer acquisition."
                    ],
                }}
                rightColumnItems={[
                    {
                        heading: "High Cost Per Conversion",
                        text: "The paid search funnel was not efficient enough, leading to higher acquisition costs and reduced campaign value.",
                    },
                    {
                        heading: "Poor Lead Quality",
                        text: "The campaigns were not consistently attracting users with strong buying intent, affecting the quality of conversions.",
                    },
                    {
                        heading: "Competitive Search Landscape",
                        text: "The brand had to compete against established print service providers with stronger visibility and mature ad accounts.",
                    },
                    {
                        heading: "Under-Optimized Campaign Structure",
                        text: "The account needed clearer campaign segmentation, dedicated ad groups, and service-specific targeting.",
                    },
                    {
                        heading: "Limited Remarketing Opportunity",
                        text: "Users leaving the website were not being re-engaged effectively, creating missed conversion opportunities.",
                    },
                    {
                        heading: "Need for Better Conversion Tracking",
                        text: "Campaign performance needed to be tracked more precisely to understand what was driving business actions.",
                    },
                ]}
            />
            <div className=" py-16 lg:py-24  relative overflow-hidden">

                <CaseStudiesMutiPurposeZigZagSection
                    sectionTitle="Our Strategic Approach"
                    sectionDescription="MMB created a performance marketing roadmap focused on building a lean, high-intent Google Ads structure. Each campaign included focused ad groups, audience-specific messaging, and clear CTAs designed to improve both click-through performance and conversion quality."

                    cards={[
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (6).svg",
                            iconAlt: "Search Visibility  ",
                            title: "Search Intent Mapping",
                            description: "Mapped keywords and ad groups around user intent, service categories, and high-conversion search behavior.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (2).svg",
                            iconAlt: "Technical SEO Foundation",
                            title: "Campaign Segmentation ",
                            description: "Structured the account into meaningful campaigns and ad groups to improve relevance, control, and performance tracking.",
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (3).svg",
                            iconAlt: "Content Growth  ",
                            title: "Conversion Rate Optimization",
                            description: "Reviewed the website experience and optimized campaign direction to support stronger lead generation outcomes.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (5).svg",
                            iconAlt: "Analytics & Optimization  ",
                            title: "Competitor Intelligence ",
                            description: "Used competitor advertising research to understand bidding behavior, ad positioning, keyword opportunities and market gaps.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (1).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Remarketing ",
                            description: "Built remarketing layers to re-engage website visitors after they left the site and bring them back into the conversion funnel.",
                            contentAlign: "center"
                        },
                        {
                            iconSrc: "/icons/StrategicApproach-icon/OhMyPrintSolutions (4).svg",
                            iconAlt: "Authority Building Framework",
                            title: "Continuous Optimization ",
                            description: "Monitored campaign performance, search terms, device behavior, ad scheduling and audience segments to improve efficiency over time.",
                            contentAlign: "center"
                        },

                    ]}
                />

            </div>

            <div className="custom-container pb-16 lg:pb-20 xl:pb-24">


                <CaseStudyEngageMentModel
                    leftImage="/hero-bg/officemeet.jpg"
                    cards={[
                        {
                            title: "Performance Marketing Sprint",
                            description: [
                                "A focused Google Ads engagement designed to launch, optimize, and scale conversion-focused paid search campaigns.",
                            ],
                        },
                        {
                            title: "Dedicated Paid Media Pod",
                            description: [
                                "Campaign strategist, Google Ads specialist, copywriter, CRO analyst and reporting resource.",
                            ],
                        },

                        {
                            title: "Optimization Rhythm",
                            description: [
                                "Ongoing monitoring of search terms, negative keywords, CTR, conversion rate, cost per conversion, phone calls and orders.",
                            ],
                        },
                        {
                            title: "Reporting Layer",
                            description: [
                                "Extensive performance reporting was used to discuss wins, gaps, campaign improvements and next steps.",
                            ],
                        },


                    ]}


                />




            </div>


            <div className="section-background-filler py-16 space-y-16">
                <CaseStudiesNewMegaCardSection
                    sectionTitle={{
                        title: "What We Did ",
                        description: "We rebuilt the Google Ads engine from the ground up to reduce acquisition costs and increase qualified conversions. ",
                        align: "left"
                    }}
                    cards={[
                        {
                          title: "Campaign Setup",
                          description:
                            "Built the Google Ads account from the ground up with structured campaigns and service-specific ad groups.",
                        },
                        {
                          title: "Competitor Research",
                          description:
                            "Analyzed competitor ad performance, positioning, and search opportunities using tools such as SpyFu and SEMrush.",
                        },
                        {
                          title: "Keyword Research",
                          description:
                            "Conducted high-search-volume keyword research focused on qualified traffic and commercial intent.",
                        },
                        {
                          title: "Ad Copy Creation",
                          description:
                            "Wrote engaging search ad copy with clear CTAs tailored to specific audience groups.",
                        },
                        {
                          title: "Conversion Tracking",
                          description:
                            "Set up conversion tracking to measure campaign actions, leads, orders, and phone call performance.",
                        },
                        {
                          title: "CRO Review",
                          description:
                            "Reviewed and optimized the website experience to improve conversion potential from paid traffic.",
                        },
                        {
                          title: "Remarketing",
                          description:
                            "Used remarketing to target precise audience groups and re-engage visitors after they left the website.",
                        },
                        {
                          title: "Location Targeting",
                          description:
                            "Refined location targeting to reach the most relevant audience segments.",
                        },
                        {
                          title: "Ad Extensions",
                          description:
                            "Added ad extensions to improve search visibility, engagement, and campaign utility.",
                        },
                        {
                          title: "Ad Scheduling",
                          description:
                            "Optimized ad delivery based on performance windows and campaign timing.",
                        },
                        {
                          title: "Device Targeting",
                          description:
                            "Monitored and optimized performance across device segments.",
                        },
                        {
                          title: "A/B Testing",
                          description:
                            "Ran split tests using different text ads within each ad group.",
                        },
                        {
                          title: "Negative Keywords",
                          description:
                            "Implemented negative keywords to reduce wasted clicks and campaign cost.",
                        },
                        {
                          title: "Quality Score Improvements",
                          description:
                            "Optimized keyword relevance, ad copy, and landing page alignment to improve quality signals.",
                        },
                        {
                          title: "Audience Testing",
                          description:
                            "Tested audience groups to identify stronger conversion opportunities.",
                        },
                      ]}

                />

                <div className="mb-12 px-6 md:px-auto xl:my-12">
                    <RedRibbonBanner title="Key Insight:">
                    Oh My Print Solutions did not need more traffic for the sake of traffic. It needed paid search traffic that was more qualified, more conversion-ready, and less expensive to acquire. 
                    </RedRibbonBanner>
                </div>

                <ImageMarquee
                    images={[
                        { src: "/CaseStudiesFolder/ShowCaseImg/OhMyPrintSolutions-ShowCaseImages/ShowCaseImg (2).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/OhMyPrintSolutions-ShowCaseImages/ShowCaseImg (1).png", alt: "Jem Jem case study" },
                        { src: "/CaseStudiesFolder/ShowCaseImg/OhMyPrintSolutions-ShowCaseImages/ShowCaseImg (3).png", alt: "Jem Jem case study" },
                    ]}
                    speed={20}
                    direction="left"
                    pauseOnHover={false}
                />


            </div>



            <section className="py-16 lg:py-20 custom-container">
                <SectionTitle
                    title="The Results "
                    description="Within three months of campaign management and optimization, the Google Ads engagement delivered stronger conversion efficiency, better user engagement and increased business actions."
                    align="center"
                    highlightSubtitle={true}
                />


                <div className="w-full overflow-x-auto mt-6">
                    <div className="inline-block min-w-full align-middle">
                        <div className="grid grid-cols-1  gap-6">

                         
                            <UniversalTable
    title="Performance Marketing Impact"
    headers={["Metric", "Result Added"]}
    rows={[
        ["Cost Per Conversion", "Reduced by 20%"],
        ["Conversion Rate", "Almost doubled in 3 months"],
        ["CTR", "Almost doubled in 3 months"],
        ["Number of Orders", "Increased by 70%"],
        ["Phone Calls", "Increased by 50%"],
    ]}
    ribbonTitle="Key Insight:"
    ribbonContent="By rebuilding the Google Ads account around intent, relevance, and conversion tracking, MMB helped the client spend more efficiently and generate stronger business outcomes from the same paid search channel."
/>

<UniversalTable
    title="Campaign Efficiency Improvements"
    headers={["Focus Area", "Business Impact"]}
    rows={[
        [
            "Campaign Segmentation",
            "Improved control over budget, service targeting and ad relevance.",
        ],
        [
            "Keyword Optimization",
            "Helped attract users with stronger commercial intent.",
        ],
        [
            "Negative Keywords",
            "Reduced irrelevant clicks and helped lower wasted spend.",
        ],
        [
            "Ad Copy Testing",
            "Improved CTR by testing audience-specific messaging and CTAs.",
        ],
        [
            "Remarketing",
            "Re-engaged previous visitors and supported additional conversion opportunities.",
        ],
        [
            "Conversion Tracking",
            "Created clearer visibility into which campaigns were producing business results.",
        ],
        [
            "CRO Review",
            "Improved the conversion readiness of paid traffic landing on the website.",
        ],
    ]}
    ribbonTitle="Key Insight:"
    ribbonContent="Continuous optimization across targeting, messaging, tracking, and remarketing helped turn Google Ads into a more efficient acquisition channel, delivering higher-quality leads at a lower cost."
/>

                            


<UniversalTable
    title="The Impact"
    headers={["Growth Area", "Impact Delivered"]}
    rows={[
        [
            "Paid Search Efficiency",
            "20% reduction in cost per conversion.",
        ],
        [
            "Engagement Quality",
            "CTR almost doubled within 3 months.",
        ],
        [
            "Conversion Performance",
            "Conversion rates almost doubled within 3 months.",
        ],
        [
            "Revenue Actions",
            "Orders increased by 70%.",
        ],
        [
            "Lead Actions",
            "Phone calls increased by 50%.",
        ],
        [
            "Campaign Control",
            "Campaigns were rebuilt with stronger targeting, ad groups and tracking.",
        ],
        [
            "Retargeting Value",
            "Remarketing helped bring previous website visitors back into the funnel.",
        ],
    ]}
    ribbonTitle="Key Insight:"
    ribbonContent="A focused Google Ads strategy helped Oh My Print Solutions move from high-cost acquisition to a more accountable paid search engine built around measurable customer actions."
/>
                        </div>
                    </div>
                </div>

            </section>





            <CommentSection quote="MMB completely restructured our Google Ads campaigns and delivered exactly what we were looking for - better-quality leads at a lower acquisition cost. The reporting was transparent, the optimizations were continuous, and the business impact was visible almost immediately." name="Oh My Print Solutions" avatarSrc={""} />

            <ToolsStack
                title="Our Tech Stack & Tools "
                description="We leveraged an integrated paid media stack to optimize campaign performance, improve conversion efficiency, and maximize return on ad spend. "
                categories={[
                    {
                        title: "Campaign Optimization",
                        items: [
                            "Negative keyword lists",
                            "Ad extensions",
                            "Scheduling",
                            "Audience testing",
                        ],
                    },
                    {
                        title: "Collaboration & Reporting",
                        items: [
                            "Google Sheets",
                            "Google Drive",
                            "Performance reporting dashboards",
                        ],
                    },
                    {
                        title: "Analytics & Reporting",
                        items: [
                            "Google Analytics",
                            "Google Ads Reports",
                            "Looker Studio",
                        ],
                    },
                    {
                        title: "Keyword Research",
                        items: [
                            "Google Keyword Planner",
                            "SEMrush",
                        ],
                    },
                    {
                        title: "CRO & Landing Page Review",
                        items: [
                            "Website audit tools",
                            "Campaign landing page analysis",
                        ],
                    },
                    {
                        title: "Conversion Tracking",
                        items: [
                            "Google Ads Conversion Tracking",
                            "Google Tag Manager",
                        ],
                    },
                    {
                        title: "Competitor Research",
                        items: [
                            "SpyFu",
                            "SEMrush",
                        ],
                    },
                    {
                        title: "Paid Search Management",
                        items: [
                            "Google Ads",
                        ],
                    },
                ]}
                withBackground={true}
            />


            <div className="pb-0 md:pb-16 xl:pb-20 relative overflow-hidden">
                <CTABanner
                    title="Ready to Make Paid Search More Profitable?"
                    description="Profitable conversions need sharper targeting, stronger tracking, better copy and continuous campaign optimization."
                    buttonText="Speak with Our Experts"
                    // buttonOnClick={handleCTAButtonClick}
                    bgColor="#313866"
                    textColor="#fff"
                    buttonVariant="primary"
                />
            </div>
            <RelatedCaseStudies />
        </main >
    );
}